document.querySelectorAll('.image-carousel-swiper').forEach((el) => {
  const section = el.closest('section');
  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    effect: 'cards',
    cardsEffect: {
      perSlideOffset: 5,
      perSlideRotate: 5,
      slideShadows: true,
    },
    navigation: {
      nextEl: section?.querySelector('.carousel-next') ?? '.carousel-next',
      prevEl: section?.querySelector('.carousel-prev') ?? '.carousel-prev',
    },
  });
});